import { ScholarshipCategoryDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadScholarshipCategory = createAction(
  '[ScholarshipCategory] Load ScholarshipCategory'
);

export const loadScholarshipCategorySuccess = createAction(
  '[ScholarshipCategory] Load ScholarshipCategory Success',
  props<{ scholarshipCategory: ScholarshipCategoryDto[] }>()
);

export const loadScholarshipCategoryFailure = createAction(
  '[ScholarshipCategory] Load ScholarshipCategory Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addScholarshipCategory = createAction(
  '[ScholarshipCategory] Add ScholarshipCategory',
  props<{ newScholarshipCategory: ScholarshipCategoryDto[] }>()
);

export const addScholarshipCategorySuccess = createAction(
  '[ScholarshipCategory] Add ScholarshipCategory Success',
  props<{ newScholarshipCategory: ScholarshipCategoryDto[] }>()
);

export const addScholarshipCategoryFailure = createAction(
  '[ScholarshipCategory] Add ScholarshipCategory Failure',
  props<{ error: any }>()
);

/**
 * Update ScholarshipCategory Collection Actions
 */
export const updateScholarshipCategory = createAction(
  '[ScholarshipCategory] Update ScholarshipCategory',
  props<{ updateScholarshipCategory: ScholarshipCategoryDto[] }>()
);

export const updateScholarshipCategorySuccess = createAction(
  '[ScholarshipCategory] Update ScholarshipCategory Success',
  props<{ updateScholarshipCategory: ScholarshipCategoryDto[] }>()
);

export const updateScholarshipCategoryFailure = createAction(
  '[ScholarshipCategory] Update ScholarshipCategory Failure',
  props<{ error: any }>()
);

/**
 * Remove ScholarshipCategory Collection Actions
 */
export const removeScholarshipCategory = createAction(
  '[ScholarshipCategory] Remove ScholarshipCategory',
  props<{ ids: string[] }>()
);

export const removeScholarshipCategorySuccess = createAction(
  '[ScholarshipCategory] Remove ScholarshipCategory Success',
  props<{ ids: string[] }>()
);

export const removeScholarshipCategoryFailure = createAction(
  '[ScholarshipCategory] Remove ScholarshipCategory Failure',
  props<{ error: any }>()
);
